import { Inbox, type LucideIcon } from 'lucide-react'
import type { ReactElement, ReactNode } from 'react'

import { cn } from '@/lib/utils'

export interface EmptyStateProps {
  /** Ícone do lucide. O painel usa uma única biblioteca de ícones. */
  readonly icone?: LucideIcon
  readonly titulo: string
  readonly descricao?: string
  /** Ação principal — normalmente um `<Button>`. */
  readonly acao?: ReactNode
  readonly className?: string
}

/**
 * Estado vazio: ícone + título + ação. Vazio nunca é uma área em branco — é
 * uma explicação e um caminho de saída.
 */
export function EmptyState({
  icone: Icone = Inbox,
  titulo,
  descricao,
  acao,
  className,
}: EmptyStateProps): ReactElement {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-border',
        'bg-surface px-6 py-14 text-center',
        className,
      )}
    >
      <span className="flex size-11 items-center justify-center rounded-full bg-elevated text-fg-muted">
        <Icone className="size-5" />
      </span>
      <h2 className="text-base font-semibold text-foreground">{titulo}</h2>
      {descricao === undefined ? null : (
        <p className="max-w-prose text-sm text-fg-secondary">{descricao}</p>
      )}
      {acao === undefined ? null : <div className="pt-1">{acao}</div>}
    </div>
  )
}
